/**
 * Nettoie les quizzes en supprimant les _tmpId 
 * @param {Array} quizzes - Tableau des quizzes
 * @returns {Array} Quizzes nettoyés
 */
export function cleanQuizzesForSave(quizzes) {
    if (!Array.isArray(quizzes)) {
        return quizzes;
    }

    return quizzes.map(quiz => {
        // Copier le quiz sans _tmpId
        const { _tmpId, ...cleanedQuiz } = quiz;

        // Nettoyer aussi les choix de quiz
        if (Array.isArray(cleanedQuiz.quizChoices)) {
            cleanedQuiz.quizChoices = cleanedQuiz.quizChoices.map(choice => {
                // Supprimer _tmpId et numero des choix
                const { _tmpId, ...cleanedChoice } = choice;
                return cleanedChoice;
            });
        }

        return cleanedQuiz;
    });
}

/**
 * Nettoie tout l'objet Contents avant sauvegarde
 * @param {Object} contents - L'objet Contents complet
 * @returns {Object} Contents nettoyé
 */
export function cleanContentsForSave(contents) {
    if (!contents) return contents;

    const cleanedContents = { ...contents };

    // Nettoyer les quizzes directement dans contents
    if (cleanedContents.quizzes) {
        cleanedContents.quizzes = cleanQuizzesForSave(cleanedContents.quizzes);
    }

    // Nettoyer les topics qui contiennent des quizzes
    if (cleanedContents.process?.topics) {
        cleanedContents.process.topics = cleanedContents.process.topics.map(topic => {
            const cleanedTopic = { ...topic };
            if (cleanedTopic.quizzes) {
                cleanedTopic.quizzes = cleanQuizzesForSave(cleanedTopic.quizzes);
            }
            return cleanedTopic;
        });
    }

    return cleanedContents;
}


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license